var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithCableDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8571 6H8.14286C6.95982 6 6 6.95982 6 8.14286V23.8571C6 25.0402 6.95982 26 8.14286 26H23.8571C25.0402 26 26 25.0402 26 23.8571V8.14286C26 6.95982 25.0402 6 23.8571 6Z",
    fill: "#8B9CB3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85163 20.1749C9.40641 20.7298 10.158 21.0414 10.9415 21.0414C11.725 21.0414 12.4766 20.7298 13.0313 20.1749L20.1629 13.0144C20.6591 12.5252 21.4665 12.5252 21.9458 13.0144C22.442 13.512 22.442 14.3133 21.9458 14.8109L18.38 18.3869L15.6165 19.9607L14.8126 20.772L14.8142 20.7737L14.2147 21.3665C14.057 21.5274 13.9687 21.744 13.9687 21.9696C13.9687 22.1952 14.057 22.4117 14.2147 22.5726L15.4089 23.7534C15.7537 24.0823 16.2667 24.0823 16.5947 23.7534L17.1858 23.169L17.1942 23.1605L18.0007 22.3518L19.5658 19.5761L23.1485 16.0001C23.6942 15.4431 24 14.6935 24 13.9126C24 13.1318 23.6942 12.3822 23.1485 11.8252C21.9879 10.6698 20.1209 10.6698 18.9771 11.8252L11.8371 18.9857C11.341 19.4749 10.5336 19.4749 10.0542 18.9857C9.55806 18.4881 9.55806 17.6869 10.0542 17.1893L13.62 13.6132L16.2092 12.2058L17.1858 11.2264L17.7854 10.6336C18.1134 10.3047 18.1134 9.76488 17.7854 9.42752L16.5912 8.24676C16.2464 7.91783 15.7334 7.91783 15.4054 8.24676L14.8142 8.83114L14.8058 8.83958L13.8292 9.81901L12.4342 12.424L8.85163 16.0001C8.30586 16.557 8.00004 17.3066 8.00004 18.0875C8.00004 18.8683 8.30586 19.618 8.85163 20.1749ZM15.9976 23.1545L14.8118 21.9654L15.4029 21.3641L16.5971 22.5617L15.9976 23.1545ZM16.5971 10.636L15.4029 9.43839L16.0025 8.84557L17.1883 10.0348L16.5971 10.636Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 6,
    y: 6,
    width: 20,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.354583 0 0 0 0 0.38985 0 0 0 0 0.575 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithCableDisabled);
export default __webpack_public_path__ + "static/media/with_cable_disabled.777c1480c33a0df3f77aa6e16d61ddb0.svg";
export { ForwardRef as ReactComponent };